import { render, staticRenderFns } from "./BlockAreaItemV2.vue?vue&type=template&id=17809ce4&scoped=true&"
import script from "./BlockAreaItemV2.vue?vue&type=script&lang=js&"
export * from "./BlockAreaItemV2.vue?vue&type=script&lang=js&"
import style0 from "./BlockAreaItemV2.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BlockAreaItemV2.vue?vue&type=style&index=1&id=17809ce4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17809ce4",
  null
  
)

export default component.exports